<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-siderbar2></app-siderbar2>
<div style="margin-bottom: 100px;">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>